module.exports = __webpack_public_path__ + "static/img/planLeft3.3c407ec5.png";